import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Soka ya Marekani",
    Baseball: "Baseboli",
    Basketball: "Mchezo wa kikapu",
    Boxing: "Ndondi",
    Chess: "Chess",
    Cricket: "Kriketi",
    Darts: "Darts",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Soka",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Gaelic Football",
    "Generic Sport": "Generic Sport",
    Golf: "Gofu",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Mpira wa mkono",
    "Ice Hockey": "Magongo thelujini",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Ligi ya Raga",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tennis Mezani",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} kushinda",
    WinFirstRound: "{name} kushinda raundi ya kwanza",
    FirstTouchdown: "{name} kupata alama ya kugusa kwanza",
    FirstTry: "{name} kupata alama ya Jaribio kwanza",
    TotalGoals: "{name} Jumla malengo",
    TotalRuns: "{name} Jumla inaendesha",
    TotalPoints: "{name} Alama za jumla",
    TopBatsman: "{name} kuwa Juu Batsman",
    TopBowler: "{name} kuwa Bowler Juu",
    FirstScore: "{name} kupata alama kwanza"
  },
  PromoTexts: {
    Pick: "Fanya chaguo zako",
    Bet: "Bet",
    Pays: "Malipo"
  },
  DateTimeTexts: {
    Today: "Leo",
    Tomorrow: "Kesho",
    Live: "Hai"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Fanya chaguo zako",
    Return: "Malipo",
    Stake: "Bet",
    Draw: "X"
  },
  H2HTexts: {
    "Goals scored": "Bao zilizotingwa",
    Shots: "Mikwaju",
    "Shots on target": "Kulenga golini",
    "Ball possession": "Kumiliki",
    "Goals conceded": "Bao zilizokubaliwa",
    "Per match": "Kwa mechi",
    H2H: "H2H",
    W: "W",
    D: "D",
    L: "L"
  }
};
